export { default as ExchangeRateCalculator } from "./components/ExchangeRateCalculator";
